import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RouteGuard } from '@shared/auth/AuthGuard';

/* Pages */
import DownloadApp from '@pages/DownloadApp';

/**
 * Enquanto o novo aplicativo (Zion Church Global) está sendo divulgado, todas as rotas
 * redirecionam para a página de download. As rotas antigas continuam disponíveis em
 * `Router.legacy.tsx` e podem ser restauradas trocando o import em `App.tsx`.
 */
const Router = () => (
  <Routes>
    <Route
      path='app'
      element={
        <RouteGuard>
          <DownloadApp title='Baixe o app da Zion' />
        </RouteGuard>
      }
    />
    <Route path='*' element={<Navigate to='/app' replace />} />
  </Routes>
);

export default Router;
